import React, {Component} from 'react';
import Action from 'components/organisms/player-name-stacking/actions';
import {connect} from 'react-redux';

class RemoveStackItem extends Component {
    removeItem(itemId) {
        this.props.dispatch(Action.do('removeItemOfPlayerNameStacking', itemId));
    }

    render() {
        const {itemId} = this.props;

        return <span onClick={() => ::this.removeItem(itemId)} className="tag-remove"></span>;
    }
}

export default connect(() => ({}))(RemoveStackItem);
